<template>
  <!-- <v-layout class="secondary" row> -->
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-switch
        v-on="on"
        class="secondary pl-2 pr-2 pt-2 pb-2 mb-0 ma-0 elevation-2"
        style="border-radius: 5px; min-height: 10px;"
        hide-details
        v-model="photoStreamIsActivated"
        color="primary"        
        label="Fotostrøm"
      ></v-switch>
    </template>
    <span>{{
      photoStreamIsActivated ? "Skjul foto i kart" : "Vis foto i kart"
    }}</span>
  </v-tooltip>
  <!-- </v-layout> -->
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import MappingMixin from "@/mixins/mappingMixin";
export default {
  name: "MapPhotoStreamToggler",
  computed: {
    ...mapState(["useDarkMode", "is3d"]),
    photoStreamIsActivated: {
      set(photoStreamIsActivated) {
        this.setPhotoStreamIsActivated(photoStreamIsActivated);
      },
      get() {
        return this.$store.state.photoStreamIsActivated;
      }
    }
  },
  mixins: [MappingMixin],
  watch: {
    is3d(newVal, oldVal) {
      if (newVal !== oldVal) {
        let photolayer = this.$theMapObject.findLayerById("foto");
        if (typeof photolayer !== "undefined") {
          if (newVal) {
            photolayer.renderer = {
              type: "simple",
              symbol: {
                type: "point-3d",
                symbolLayers: [
                  {
                    type: "icon",
                    resource: {
                      href: "/svg/Photo.svg"
                    },
                    size: 20,
                    outline: {
                      color: "white",
                      size: 2
                    }
                  }
                ],

                verticalOffset: {
                  screenLength: 40,
                  maxWorldLength: 200,
                  minWorldLength: 35
                },

                callout: {
                  type: "line",
                  color: "white",
                  size: 2
                }
              }
            };
          } else {
            let photolayer = this.$theMapObject.findLayerById("foto");

            photolayer.renderer = {
              type: "simple",
              symbol: {
                type: "picture-marker",
                url: "/svg/Photo.svg",
                width: "20px",
                height: "20px"
              },
              visualVariables: [
                {
                  type: "size",
                  valueExpression: "$view.scale",
                  stops: [
                    { value: 25833, size: 20 },
                    { value: 25833 * 2, size: 15 },
                    { value: 25833 * 4, size: 15 },
                    { value: 25833 * 8, size: 15 }
                  ]
                }
              ]
            };
          }
        }
      }
    },
    photoStreamIsActivated(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.togglePhotoStreamLayer(newVal);
      }
    }
  },
  methods: {
    ...mapActions(["setPhotoStreamIsActivated"]),
    togglePhotoStreamLayer: function(newVal) {
      let photolayer = Vue.prototype.$theMapObject.findLayerById("foto");
      if (newVal && !photolayer) {
        this.addMapProfile({
          id: "foto",
          type: "featureLayer",
          showInfoMenu: false,
          visible: true
        });
      } else {
        this.removeMapProfile("foto");
      }
    }
  }
};
</script>

<style></style>
